<template>
    <div class="content">
        <section>
            <div class="content-box">
                <div class="text-center py-4"
                    style="background: url('/assets/header_bg.png'); background-repeat: no-repeat; background-size: 100% 100%;">
                    <h1 style="color:#FFCD05; margin:0; padding:0; line-height:1em;">
                        About
                    </h1>
                    <h2
                        style="color:#FFF; text-transform:uppercase; font-size:45px; font-weight:bolder; margin:0; padding:0; line-height:1em;">
                        EUROPE LOTTO
                    </h2>
                    <p style="color:#FFF; text-align: justify; font-size:13px; margin:0; padding:0; margin-bottom:20px;line-height: 1.7em;"
                        class="mt-4 px-3">
                        Welcome to our official website EUROPE LOTTO. We are the best online betting website that
                        presents lottery number games. We use the best technology and safe systems to ensure our members
                        can enjoy their best moments while playing on our website.</p>
                    <p style="color:#FFF; text-align: justify; font-size:13px; margin:0; padding:0; margin-bottom:20px;line-height: 1.7em;"
                        class="mt-4 px-3">
                        We have 3D, 4D & 5D number games for our beloved members who like to guess numbers and valuable
                        numbers. We also provide a EUROPE LOTTO Number Frequency Table which can be used to guess the
                        next number. Register now and play to win your unlimited prizess.
                    </p>
                    <br><br><br><br>
                </div>

                <img src="/assets/about_image.png" class="img-fluid" style="width: 100%;margin-top: -100px;" />


            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: 'AboutPage',
    components: {
    }
}
</script>

<style scoped></style>
